export default __webpack_public_path__ + "static/media/links.1a3afdf1.svg";